
<template>
  <div class="botao">
    <button @click="logout">Sair</button>
  </div>
</template>


<script setup >
import { useRouter } from 'vue-router'

const router = useRouter()

const logout = () => {
  localStorage.removeItem('authToken')
  router.push({ name: 'login' })
}

</script>

<style scoped> 
.botao{

  height: 30px;

}
  button{
    background-color: #0089ff ;
    color: white;
    border: none;
    width: 100%;
    padding: 5%;
    border-radius: 3%;
  }
</style>